import {
  CANCEL_EQUEUE_FAILED,
  CLEAR_EQUEUES_LIST,
  EQUEUE_BOOKING_FAILED,
  EQUEUE_BOOKING_SUCCESS,
  EQUEUES_LIST_LOADING_FAILED,
  EQUEUES_LIST_LOADING_SUCCESS, SET_CUSTOM_ERROR_MESSAGE,
  SET_EXCEPTIONS,
} from "./types";
import { EQUEUES_LIST_ADDRESS, panels } from "../../variables";
import {
  hideBookingLoader,
  hideCancelEqueuesLoader,
  hideConfirmLoader,
  hideQueuesLoader,
  showBookingLoader,
  showCancelEqueuesLoader,
  showConfirmLoader,
  showQueuesLoader,
  showSelectedEqueueLoader,
  hideSelectedEqueueLoader,
} from "./loaderActions";
import { restartPanelsHistory, setActivePanel } from "./panelsActions";
import { checkErrorStatusAndExecuteCallback } from "../../utils";
import { userInfoLoadingStarted } from "./userInfoActions";

import store from "../store";
import { selectEqueue, selectEqueueLoadingStart } from "./selectedEqueueAction";
import {DDOS_STATUS_CODE} from "../../constants/statusCodes";
import {setMetrics} from "../../helpers/metrics";
import Api from "../../api";
import { HealthCheckEvents } from "../../api/types";
import { throwErrorMessageFromResponse } from "../../helpers/redux";

export const equeuesLoadingStarted = () => (dispatch) => {
  const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getBookingList);

  dispatch(showQueuesLoader());
  var config = {
    method: "get",
    withCredentials: true,
    params: {
      pageSize: 100
    }
  };
  Api.instance.get(EQUEUES_LIST_ADDRESS, config)
    .then((response) => {
      const { hasMore, items } = response.data;
      const exceptions = items.filter(x => x.status === "done").map((equeue) =>
        new Date(equeue.data.snippets[0].localDate).getTime()
    );
      dispatch(equeuesLoadingSuccess({ hasMore, items, exceptions }));

      healthCheckInstance.sendSuccess();
    })
    .catch((error) => {
      console.debug("Debug error")
      console.debug(error)
      dispatch(equeuesLoadingFailed(error));
      setMetrics('reachGoal','OldHealth.BookingListError');
      healthCheckInstance.sendFailure({ browserError: error.message });
      checkErrorStatusAndExecuteCallback(error, () =>
        dispatch(setActivePanel(panels.error))
      );

      if (error.response?.status !== DDOS_STATUS_CODE ) {
        dispatch(equeuesLoadingFailed(error));
        checkErrorStatusAndExecuteCallback(error, () =>
          dispatch(setActivePanel(panels.error))
        );
      }
    })
    .finally(() => dispatch(hideQueuesLoader()));
};

export const equeuesLoadingSuccess = ({ hasMore, items, exceptions }) => {
  return {
    type: EQUEUES_LIST_LOADING_SUCCESS,
    payload: {
      hasMore,
      items,
      exceptions,
    },
  };
};

export const equeuesLoadingFailed = (e) => {
  return {
    type: EQUEUES_LIST_LOADING_FAILED,
    payload: e,
  };
};
export const setExceptions = (time) => {
  return {
    type: SET_EXCEPTIONS,
    payload: time,
  };
};

export const setCustomErrorMessage = (message) => {
  return {
    type: SET_CUSTOM_ERROR_MESSAGE,
    payload: message,
  };
};


export const cancelEqueueStart = (extId, eserviceId) => (dispatch) => {
  const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.cancelBooking);

  // TODO: Aliakseyeu. Fix hardcoded eserviceId.
  // From 'selected-equeue' request we got eserviceId = 33090, but for SMEV3
  // we must use eserviceId = 10000103595.
  const serviceId = '10000103595';

  dispatch(showCancelEqueuesLoader());
  dispatch(showSelectedEqueueLoader());

  // TODO: Aliakseyeu. Make interval response check of equeue data.
  // Server sends response before actual database update.
  // And before next 2s - 2.5s will be received outdated response data.
  // For now set timeout for 4s.
  Api.instance.post("/health/v2/calendar/events/" +extId + "/cancel?eserviceId=" + serviceId)
    .then(() => {
      setMetrics('reachGoal','OldHealth.CancelBooking');
      healthCheckInstance.sendSuccess();
      setTimeout(() => {
        dispatch(restartPanelsHistory());
        dispatch(hideCancelEqueuesLoader());
        dispatch(hideSelectedEqueueLoader());
      }, 4000);
    })
    .catch(function (error) {
      setMetrics('reachGoal','OldHealth.CancelBookingError');
      healthCheckInstance.sendFailure({ browserError: error.message });
      if (error.response) {
        if (error.response.status >= 400 && error.response.status < 600) {
          if (error.response.status === 403) {
            dispatch(setActivePanel(panels.removeOldRecordError));
          } else {
            dispatch(setActivePanel(panels.error));
          }
        }
      }
      dispatch(hideCancelEqueuesLoader());
      dispatch(hideSelectedEqueueLoader());
    });
};

export const cancelEqueueFailed = (e) => {
  return {
    type: CANCEL_EQUEUE_FAILED,
    payload: e,
  };
};

export const startEqueueBooking =
  (
    selectedSlot,
    sessionId,
    selectedMedicalOrganisation,
    selectedRegion,
    orderId,
    selectedDoctorName,
    selectedDoctorSpeciality,
    userInfo,
    enteredOms
  ) =>
  (dispatch) => {
    const healCheckInstance = Api.healthCheckFor(HealthCheckEvents.booking);
    const apiBase = store.getState().addresses.apiBase;

    let data = {
      address: selectedMedicalOrganisation.Address_MO,
      orgName: selectedMedicalOrganisation.Organization_Name,
      subject: "Запись на приём к врачу",
      userSelectedRegion: selectedRegion.OKATO,
      params: [
        {
          name: "doctor",
          value: selectedDoctorSpeciality.Service_Name,
        },
        {
          name: "anotherperson",
          value: "N",
        },
        {
          name: "genderperson",
          value: userInfo.gender,
        },
        {
          name: "ageperson",
          value: "",
        },
        {
          name: "pacientname",
          value: userInfo.formattedName,
        },
        {
          name: "doctorname",
          value: selectedDoctorName.Resource_Name,
        },
        {
          name: "doctorid",
          value: selectedDoctorName.Resource_Id,
        },
      ],
      eserviceId: "10000103595",
      serviceCode: "-10001000603",
      bookId: sessionId,
      organizationId:
        selectedMedicalOrganisation.value || selectedMedicalOrganisation.MO_Id,
      calendarName: "на прием к врачу",
      areaId: [selectedRegion.regionCode],
      parentOrderId: "",
      caseNumber: orderId,
      attributes: [
        {
          name: "Session_Id",
          value: sessionId,
        },
      ],
      slotId: [selectedSlot.slotId],
      serviceId: ["10001000603"],
    };

    dispatch(showBookingLoader());
    let config = {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    };
    dispatch(showConfirmLoader());
    let dataStatus
    Api.instance.post("/health/v2/record?srcSystem=BETA", data, config)
      .then((response) => {
        dataStatus = response.data

        if (response.data.status.statusCode !== 201) {
          throw new Error(response.data.status.statusMessage);
        }

        throwErrorMessageFromResponse(response);

        const payload = "EQUEUE/" + response.data.bookId;

        healCheckInstance.sendSuccess();

        dispatch(clearEqueuesList());

        setTimeout(() => {
          dispatch(userInfoLoadingStarted(enteredOms, false));
          dispatch(selectEqueue(payload));
          dispatch(selectEqueueLoadingStart(payload, 0, true));

        }, 400); // для показа экрана с записью нужен таймаут, т.к. без него сервер возвращает 404
      })
      .catch((error) => {
        healCheckInstance.sendFailure({ browserError: error.message });
        dispatch(equeuesLoadingFailed(error));
        dispatch(hideConfirmLoader());
        dispatch(hideBookingLoader());
        if (dataStatus?.error?.errorDetail?.errorCode > 0) {
          dispatch(setCustomErrorMessage(dataStatus?.error?.errorDetail?.errorMessage))
          dispatch(setActivePanel(panels.customError));
          return
        }
        if (dataStatus?.status?.statusMessage) {
          dispatch(setCustomErrorMessage(dataStatus?.status?.statusMessage))
          dispatch(setActivePanel(panels.customError));
          return;
        }
        dispatch(setActivePanel(panels.error));
      });
  };

export const equeueBookingSuccess = () => {
  setMetrics('reachGoal','OldHealth.Booking');
  return {
    type: EQUEUE_BOOKING_SUCCESS,
  };
};

export const equeueBookingFailed = (error) => {
  setMetrics('reachGoal','OldHealth.BookingError');
  return {
    type: EQUEUE_BOOKING_FAILED,
    payload: {
      error,
    },
  };
};

export const clearEqueuesList = () => {
  return {
    type: CLEAR_EQUEUES_LIST,
  };
};
